module.exports = __webpack_public_path__ + "img/empreendimento-logo-38.800eaf3f.png";